const isFunction = (
  possibleFunction: any,
): possibleFunction is Function => {
  return (
    Object.prototype.toString.call(possibleFunction) ===
    '[object Function]'
  )
}

const isString = (possibleString: any): possibleString is string =>
  Object.prototype.toString.call(possibleString) === '[object String]'

interface HasLength {
  length: number
}
type IsEmptyString = <Type extends HasLength>(
  possibleEmptyString: Type,
) => boolean
const isEmptyString: IsEmptyString = (possibleEmptyString): boolean =>
  isString(possibleEmptyString) && possibleEmptyString.length === 0

const objectHasProperty = (obj: object, key: string): boolean =>
  Object.prototype.hasOwnProperty.call(obj, key)

const isObject = (possibleObj: any): possibleObj is object =>
  Object.prototype.toString.call(possibleObj) === '[object Object]'

const getCookieByName = (name: string): string | null => {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) {
    return parts.pop()!.split(';').shift()!
  }

  return null
}

const getHashParamsObj = (): URLSearchParams => {
  const queryString = window.location.hash.replace('#', '&')
  return new URLSearchParams(queryString)
}

const hasHashParam = (key: string): boolean => {
  return getHashParamsObj().has(key)
}

const getHashParam = (key: string): string | null => {
  const paramsObj = getHashParamsObj().get(key)
  if (isString(paramsObj)) return decodeURI(paramsObj)
  return null
}

export {
  isString,
  isEmptyString,
  objectHasProperty,
  isObject,
  isFunction,
  getCookieByName,
  getHashParamsObj,
  hasHashParam,
  getHashParam,
}
